import api from "./httpClient";

/**
 * Returns terminals/branches assigned to the current user.
 * Backend: GET /api/User/MyBranches  (requires [Authorize])
 *
 * Expected response: BranchForUser[] where BranchForUser = { id, name, ex, dr }
 */
export async function getMyBranches(signal) {
	const resp = await api.get("/User/MyBranches", { signal });
	const payload = resp?.data;

	if (Array.isArray(payload)) return payload;
	if (Array.isArray(payload?.data)) return payload.data;

	return [];
}
